import React from "react";
import Input from "Input"

const ProductViewHeader = ({
  searchTerm,
  setSearchTerm,
  selectedCategoryId,
  setSelectedCategoryId,
  activeCategories,
  scrollToCategory
}) => {
  return(
    <div className="is-flex card is-justify-content-space-between is-align-items-center mb-4 mt-2" style={{position: "sticky", top: 0, backgroundColor: "white", zIndex: 21}}>
      <div className="is-flex-grow-2 mr-4">
        <Input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={setSearchTerm}
        />
      </div>
      <div className="select">
        <select
          value={selectedCategoryId}
          onChange={(e) => {
            const categoryId = e.target.value
            setSelectedCategoryId(categoryId)
            scrollToCategory(categoryId)
          }}
        >
          <option value="">Jump to Category</option>
          {activeCategories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default ProductViewHeader
